<template>
  <div class="LanguageSet">
      <div class="buttonBox">
        <el-button type="primary" :style="{'fontSize':fonts}" size="mini" @click="addClick">{{$t("LanguageSet.add")}}</el-button>
      </div>
      <div class="tableBox">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="ks" :label="language" align="center"></el-table-column>
          <el-table-column prop="v1" :label="content" align="center"></el-table-column>
           <el-table-column fixed="right" :label="operation" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" circle @click="setData(scope)"></el-button>
              <el-button type="text" icon="el-icon-delete" circle @click="deleteData(scope)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog :title="titles" :visible.sync="dialogFormVisible" width="30%" append-to-body>
        <el-form :model="form" label-width="100px">
          <el-form-item :label="language">
            <el-select v-model="form.k" @change="LanguageChange" @visible-change="visibleChange" clearable filterable :placeholder="$t('placeHolder.pleaseSelect')">
               <el-option
                label="中文(简体)"
                value="zh-cn"
              >
                <span style="float: left">中文(简体)</span>
                <span style="float: right; color: #8492a6; font-size: 13px">zh-cn</span>
              </el-option>
              <el-option
                v-for="(item, index) in Languageoptions"
                :key="index"
                :label="item.langName"
                :value="item.langCode"
              >
                <span style="float: left">{{ item.langName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.langCode }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="content">
            <el-input v-model="form.v1" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisibleNO">{{$t('LanguageSet.cancel')}}</el-button>
          <el-button type="primary" @click="dialogFormVisibleYES">{{$t("LanguageSet.confirm")}}</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import { getLanguageTpye, getLanguageList, setLanguageList } from "@/api/LanguageSet.js"
import { checkFont } from '@/utils/methods';
export default {
  name: 'languageSet',
  props: {
    dataIdFour: {
      type: String,
      default: ''
    },
    typeFour: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      tableData: [],
      titles: "新增",
      dialogFormVisible: false,
      visibleChangeTitle: '',
      form: {
        k: null,
        v1: null
      },
      Languageoptions: [],
      rowIndex: 0,
      language: this.$t("LanguageSet.language"),
      content: this.$t("LanguageSet.content"),
      operation: this.$t("LanguageSet.operation"),
      fonts: null,
      dataId: '',
      dataType: null
    };
  },
  watch: {
    dataIdFour: {
      handler(newVal, oldVal) {
        this.dataId = newVal
      }, deep: true, immediate: true
    },
    typeFour: {
      handler(newVal, oldVal) {
        this.dataType = newVal
      }, deep: true, immediate: true
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.init()
    let font = checkFont()
    this.fonts = font
    let all = document.getElementsByTagName('*'),
        reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
    for(var i=0;i<all.length;i++) {
      if(reg.test(all[i].innerText)) {
        all[i].style.fontSize = font;
      }
    }
  },
  methods: {
    init () {
      getLanguageTpye().then(res => {
        this.Languageoptions = res
        let data = {
          businessId: this.$route.params.id || this.dataId,
          type: this.$route.params.type == null ? this.dataType : this.$route.params.type
        }
        getLanguageList(data).then(res => {
          for (let i = 0; i < res.length; i ++) {
            if (res[i].k == "zh-cn") {
              res[i].ks = "中文(简体)"
            } else {
              for (let j = 0; j < this.Languageoptions.length; j ++) {
                if (res[i].k == this.Languageoptions[j].langCode) {
                  res[i].ks = this.Languageoptions[j].langName
                  break;
                }
              }
            }
          }
          this.tableData = res
        })
      })
    },
    visibleChange () {
      this.visibleChangeTitle = this.form.k
    },
    LanguageChange (val) {
      for (let i = 0; i < this.tableData.length; i ++) {
        if (this.tableData[i].k == val) {
          this.$message({
            message: this.$t('addTips.languageNoRepeat'),
            type: 'warning'
          })
          this.form.k = this.visibleChangeTitle
          break;
        }
      }
    },
    setData (row) {
      this.titles = this.$t('LanguageSet.edit')
      delete row.row.ks
      this.dialogFormVisible = true
      this.form = Object.assign({}, row.row)
      this.rowIndex = row.$index
    },
    deleteData (row) {
      let tableList = Object.assign([], this.tableData)
      this.$confirm(this.$t('configMoudle.confirmDelete'), this.$t('configMoudle.tip'), {
        confirmButtonText: this.$t('configMoudle.confirm'),
        cancelButtonText: this.$t('configMoudle.cancel'),
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('configMoudle.tip6')
        });
        tableList.splice(row.$index, 1)
        this.setList(tableList)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    addClick () {
      this.titles = this.$t("LanguageSet.add")
      this.form = {
        k: null,
        v1: null
      }
      this.dialogFormVisible = true
    },
    dialogFormVisibleNO () {
      this.dialogFormVisible = false
    },
    dialogFormVisibleYES () {
      let tableList = Object.assign([], this.tableData)
      if (this.form.k == "" || this.form.k == null || this.form.k == undefined) {
        this.$message({
          message:this.$t("LanguageSet.languageRequire"),
          type: 'warning'
        })
      } else if (this.form.v1 == "" || this.form.v1 == null || this.form.v1 == undefined) {
        this.$message({
          message: this.$t("LanguageSet.contentRequire"),
          type: 'warning'
        })
      } else {
        if (this.titles ==this.$t("LanguageSet.add")) {
          this.dialogFormVisible = false
          tableList.push(this.form)
          this.setList(tableList)
        } else if (this.$t('LanguageSet.edit')) {
          this.dialogFormVisible = false
          for (let j = 0; j < this.Languageoptions.length; j ++) {
            if (this.form.k == this.Languageoptions[j].langCode) {
              this.form.ks = this.Languageoptions[j].langName
              break;
            }
          }
          tableList.splice(this.rowIndex, 1, this.form)
          this.setList(tableList)
        }
      }
    },
    setList (datalist) {
      let data = {
        businessId: this.$route.params.id || this.dataId,
        type: this.$route.params.type == null ? this.dataType : this.$route.params.type,
      }
      for (let i = 0; i < datalist.length; i ++) {
        if (datalist[i].ks) {
          delete datalist[i].ks
        }
      }
      setLanguageList(data, datalist).then(res => {
        this.init()
      })
    },
  },
  components: {},
};
</script>
<style scoped lang="scss">
.buttonBox {
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
}
.tableBox {
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  .el-button {
    padding: 0;
  }
}
.el-form .el-form-item {
  margin: 10px 0;
}
</style>

